import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BaseComponent } from 'src/app/core/components/base.component';
import MaxLengths from 'src/app/core/constants/max-lengths';
import { customValidator } from 'src/app/core/validators/custom.validator';
const postalCodeLength: number = 4;
const blockedPostalCodes: string[] = ['9485', '9486', '9487', '9488', '9489', '9490', '9491', '9492', '9493', '9494', '9495', '9496', '9497', '9498', '9499'];

@Component({
  selector: 'postal-code',
  templateUrl: './postal-code.component.html',
  styleUrls: ['./postal-code.component.scss']
})
export class PostalCodeComponent extends BaseComponent implements OnInit {
  @Input() postalCodeControl: FormControl | any;
  @Input() label: string | any;
  @Input() maxLength: number | any = null;
  @Input() checkBlocked: boolean = false;
  @Output() result = new EventEmitter<string | null>();

  maxLengths = MaxLengths;
  // formGroup = this.formBuilder.group({
  //   item: this.formBuilder.control(null, customValidator(() => this.postalCodeControl.invalid, () => this.postalCodeControl.errors))
  // });

  form : any = new FormGroup({
    item: new FormControl(null, customValidator(() => this.postalCodeControl.invalid, () => this.postalCodeControl.errors))
  });

  constructor(
    //private readonly cityService: CityService
    ) {
    super();
  }

  ngOnInit() {
    this.postalCodeControl.statusChanges
      .unsubscribeOnDestroy(this)
      .subscribe(() => {
        this.itemControl.updateValueAndValidity();
      });

    this.postalCodeControl.valueChanges
      .unsubscribeOnDestroy(this)
      .subscribe((value: string) => {
        this.itemControl.setValue(value);
      });

    // Set initial value
    this.itemControl.setValue(this.postalCodeControl.value);
  }

  postalCodeChanged() {
    this.postalCodeControl.setValue(this.itemControl.value);
    if (this.checkBlocked) {
      if (blockedPostalCodes.indexOf(this.itemControl.value) !== -1) {
        this.postalCodeControl.setErrors({ 'blocked': true });
      }
      else if (!this.itemControl.hasError('pattern')) {
        this.itemControl.markAsPristine();
      }
    }

    // if (this.itemControl.value?.length == postalCodeLength) {
    //   this.cityService.getByPostalCode(this.itemControl.value)
    //     .subscribe(value => {
    //       if (value && value.queryAutoComplete3Result) {
    //         if (value.queryAutoComplete3Result.autoCompleteResult.length > 0) {
    //           var city = value.queryAutoComplete3Result.autoCompleteResult[0].townName;
    //           this.result.emit(city);
    //         }
    //         else {
    //           this.result.emit(null);
    //         }
    //       }
    //     });
    // }
  }

  ngDoCheck() {
    if (this.postalCodeControl.touched && !this.itemControl.touched) {
      this.itemControl.markAsTouched();
    }

    if (this.postalCodeControl.disabled && !this.itemControl.disabled) {
      this.itemControl.disable();
    }

    if (this.postalCodeControl.enabled && !this.itemControl.enabled) {
      this.itemControl.enable();
    }
  }

  get itemControl(): FormControl {
    return this.form.controls.item as FormControl;
  }
}
